import Vue from 'vue';
import Promise from 'bluebird';
import { ensureSod } from './utils';
var Linker = (function () {
    function Linker(ns) {
        this._scripts = {};
        this._vues = {};
        this._rev = '';
        this._ns = '$itacs';
        this._rev = window[ns].rev;
        this._ns = ns;
    }
    Linker.prototype.register = function (key, component) {
        this._vues[key] = component;
    };
    Linker.prototype.create = function (key, props, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        if (!options.target) {
            var currentScript = document.scripts[document.scripts.length - 1];
            options.target = document.createElement('div');
            currentScript.parentElement.insertBefore(options.target, currentScript);
        }
        ensureSod('sp.init.js', 'SP.Guid').then(function () {
            return _this.ensureScript(key).then(function () {
                var vue = _this._vues[key];
                new Vue({
                    el: options.target,
                    render: function (h) {
                        return h(vue, { props: props });
                    }
                });
            });
        });
    };
    Linker.prototype.ensureScript = function (key) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this._vues[key]) {
                resolve();
                return;
            }
            var script = _this._scripts[key];
            if (!script) {
                var filename = key + ".js?rev=" + _this._rev;
                var url = window[_this._ns].cdnBasePath + "/" + filename;
                _this._scripts[key] = url;
                SP.SOD.registerSod(filename, url);
                SP.SOD.executeFunc(filename, null, function () {
                    resolve();
                });
            }
            else {
                resolve();
            }
        });
    };
    return Linker;
}());
export { Linker };
export default Linker;
